module.exports = __webpack_public_path__ + "03_short_beige.40a867f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_short_beige.png
// module id = kOgu
// module chunks = 0